import { azureSpeechService } from "../azureSpeechService";
import { getAzureToken } from "../azureTokenClient";
import { SttBackend, SttRecognitionOptions } from "./types";

let supportProbe: Promise<boolean> | null = null;

async function probeSupport(): Promise<boolean> {
  try {
    await getAzureToken();
    return true;
  } catch {
    return false;
  }
}

export const azureSttBackend: SttBackend = {
  name: "azure",

  isSupported(): Promise<boolean> {
    if (!supportProbe) supportProbe = probeSupport();
    return supportProbe;
  },

  async startRecognition(opts: SttRecognitionOptions): Promise<void> {
    let viaTimeout = false;
    return azureSpeechService.startRecognition({
      language: opts.language,
      silenceTimeout: opts.silenceTimeout,
      onStart: opts.onStart,
      onInterimResult: opts.onInterimResult,
      onFinalResult: opts.onFinalResult,
      onError: opts.onError,
      onTimeout: () => {
        viaTimeout = true;
      },
      onEnd: () => opts.onEnd?.({ viaTimeout }),
    });
  },

  async stopRecognition(): Promise<void> {
    return azureSpeechService.stopRecognition();
  },
};
